// Şub 27, 2026 — DPD "Bugün için veri eksik olabilir" bilgilendirme banner'ı
// DPD raporları bir güne ait 3 farklı dosyayla oluşur:
//   - Gün başı (RouteDataLog sabah 10:00): boş, henüz teslimatlar yapılmadı
//   - Gün ortası (Retour Report): iade paketleri
//   - Gün sonu (RouteDataLog akşam 23:45): NİHAİ, tüm veriler dolu
// Otomatik cron 00:10'da çalıştığı için dün ve öncesi hep tam. Ama BUGÜN
// için seçim yaparken kullanıcı bilmeli: rakamlar akşam nihai raporu gelene
// kadar (23:45+) eksik olabilir.
//
// Usage:
//   <TodayIncompleteBanner date="2026-09-24" />
//   → Eğer date === bugün (Europe/Brussels) ise sarı uyarı banner'ı çıkar.
//   → Aksi halde hiçbir şey render etmez (null).
import { Info } from 'lucide-react';

function todayISOInBrussels() {
  // Europe/Brussels timezone'a göre bugünün YYYY-MM-DD stringini üretir.
  // Kullanıcı Türkiye'de olsa bile veri kaynağı DPD Belçika olduğundan
  // Belçika günü baz alınır.
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(new Date());
    const y = parts.find(p => p.type === 'year')?.value;
    const m = parts.find(p => p.type === 'month')?.value;
    const d = parts.find(p => p.type === 'day')?.value;
    return `${y}-${m}-${d}`;
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

export default function TodayIncompleteBanner({ date, variant = 'daily' }) {
  if (!date) return null;
  const today = todayISOInBrussels();
  if (date !== today) return null;
  // Variant'a göre metni değiştir
  const messages = {
    daily: {
      title: 'Bugün için rapor henüz tamamlanmadı',
      body: 'DPD gün sonu raporunu (akşam 23:45\'te) gönderiyor — o zamana kadar teslim, retour ve stops sayıları eksik/güncel olmayabilir. Otomatik aktarım gece 00:10\'da çalışır. Dün ve önceki günlerin rakamları tamdır.',
    },
    retour: {
      title: 'Bugünkü iadeler gün içinde güncellenmeye devam ediyor',
      body: 'Retour raporu gün içinde birden fazla kez gelir; kesin sayıya akşam nihai raporundan sonra ulaşılır.',
    },
    consolidated: {
      title: 'Bugünkü konsolide rapor tamamlanmamış olabilir',
      body: 'RouteDataLog nihai versiyonu akşam 23:45\'te gelir, retour ve stops raporları da gün içinde güncellenir. Otomatik ingest 00:10\'da bir kez daha çalışıp verileri tazeler.',
    },
  };
  const msg = messages[variant] || messages.daily;

  return (
    <div
      className="mb-4 rounded-lg border border-amber-200 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-800 p-3 flex items-start gap-2.5"
      data-testid={`dpd-today-incomplete-banner-${variant}`}
      role="status"
    >
      <Info className="h-4 w-4 text-amber-700 dark:text-amber-300 flex-shrink-0 mt-0.5" />
      <div className="flex-1 text-[12px]">
        <div className="font-semibold text-amber-900 dark:text-amber-200">{msg.title}</div>
        <div className="text-amber-800 dark:text-amber-300 mt-0.5">{msg.body}</div>
      </div>
    </div>
  );
}
